export default "__VITE_ASSET__BSVUmELT__"